module.exports = __webpack_public_path__ + "f4ccec079c7b5768f2f1db625697f1d5.svg";